<avi-state-page
    class="tech-support-page"
    [hasSidebar]="true"
>
    <avi-state-page_main-content>
        <avi-page-header
            headerText="{{ l10nKeys.headerLabel | vtranslate }}"
            [showEditButton]="isTechSupportProfileItemPresent()"
            (onButtonClick)="editTechSupport()"
        ></avi-page-header>
        <tech-support-page-card class="tech-support-page__card"></tech-support-page-card>
        <div
            class="tech-support-page__grid"
            *ngIf="showTechSupportGrid"
        >
            <avi-collection-data-grid
                [config]="techSupportGridConfig"
                gridTitle="{{ l10nKeys.completedPackagesGridLabel | vtranslate : completePackagesCount }}"
            >
                <ng-template
                    #resourceNameTemplateRef
                    let-row
                >
                    <a
                        href=""
                        (click)="redirectToTechSupportDetailsPage(row, $event)"
                    >
                        {{ row.getConfig().name || '-' }}
                    </a>
                </ng-template>
                <ng-template
                    #techSupportResultsTemplateRef
                    let-row
                >
                    <ng-container *ngIf="row.data?.config?.state?.config?.state === techSupportState.inProgress">
                        <clr-spinner [clrSmall]="true"></clr-spinner>
                        <span class="tech-support-page__progress-label">
                            {{ l10nKeys.inProgressLabel | vtranslate }}
                        </span>
                    </ng-container>
                    <ng-container *ngIf="row.data?.config?.state?.config?.state === techSupportState.success">
                        <cds-icon
                            status="success"
                            shape="check-circle"
                            size="20"
                        ></cds-icon>
                        <span>{{ l10nKeys.completedLabel | vtranslate }}</span>
                    </ng-container>
                    <ng-container *ngIf="row.data?.config?.state?.config?.state === techSupportState.error">
                        <cds-icon
                            status="danger"
                            shape="exclamation-circle"
                            size="20"
                        ></cds-icon>
                        <span>{{ l10nKeys.errorLabel | vtranslate }}</span>
                    </ng-container>
                    <ng-container *ngIf="row.data?.config?.state?.config?.state === techSupportState.completedWithWarnings">
                        <cds-icon
                            status="warning"
                            shape="exclamation-triangle"
                            size="20"
                        ></cds-icon>
                        <span>{{ l10nKeys.completedWithWarningsLabel | vtranslate }}</span>
                    </ng-container>
                    <ng-container *ngIf="row.data?.config?.state?.config?.state === techSupportState.warning">
                        <cds-icon
                            status="warning"
                            shape="exclamation-triangle"
                            size="20"
                        ></cds-icon>
                        <span>{{ l10nKeys.warningLabel | vtranslate }}</span>
                    </ng-container>
                </ng-template>
                <ng-template
                    #techSupportExpanderTemplateRef
                    let-row
                >
                    <div class="tech-support-page__expander-content">
                        <div class="tech-support-page__expand-row">
                            <div class="tech-support-page__key">
                                {{ l10nKeys.fileNameLabel | vtranslate }}
                            </div>
                            <div>{{ row.getFileName() }}</div>
                        </div>
                        <div class="tech-support-page__expand-row">
                            <div class="tech-support-page__key">
                                {{ globalL10nKeys.startTimeLabel | vtranslate }}
                            </div>
                            <div>{{ row.data.config.start_time }}</div>
                        </div>
                    </div>
                    <div class="tech-support-page__expander-content">
                        <div class="tech-support-page__expand-row">
                            <div class="tech-support-page__key">
                                {{ globalL10nKeys.reasonLabel | vtranslate }}
                            </div>
                            <div>{{ row.data.config.state.data.config.reason }}</div>
                        </div>
                        <div class="tech-support-page__expand-row">
                            <div class="tech-support-page__key">
                                {{ globalL10nKeys.endTimeLabel | vtranslate }}
                            </div>
                            <div>{{ row.data.config.end_time }}</div>
                        </div>
                    </div>
                    <div class="tech-support-page__expander-content">
                        <div class="tech-support-page__expand-row">
                            <div class="tech-support-page__key">
                                {{ globalL10nKeys.descriptionLabel | vtranslate }}
                            </div>
                            <div>{{ row.data.config.description }}</div>
                        </div>
                    </div>
                </ng-template>
            </avi-collection-data-grid>
        </div>
    </avi-state-page_main-content>

    <avi-state-page_sidebar>
        <div
            *ngIf="loadingRecentTechSupport"
            class="tech_support__setup-info"
        >
            <clr-spinner
                clrMedium
                class="tech_support__loader"
            ></clr-spinner>
            <span class="tech_support__setup-info-label">{{ l10nKeys.loadingRecentLabel | vtranslate }}</span>
        </div>
        <recent-tech-support-list
            *ngIf="!loadingRecentTechSupport"
            [nodeType]="recentNodeType"
            [node]="recentTechSupport"
        ></recent-tech-support-list>
    </avi-state-page_sidebar>
</avi-state-page>
